export function readableMissingTranslation(key: string) {
  const segment = key.split(".").filter(Boolean).at(-1) || key;
  const text = segment.replaceAll("_", " ").replaceAll("-", " ").trim();
  return text ? text.charAt(0).toLocaleUpperCase() + text.slice(1) : key;
}
